"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EAuthType;
(function (EAuthType) {
    EAuthType["basic"] = "basic";
})(EAuthType = exports.EAuthType || (exports.EAuthType = {}));
var EHtmlSelectorActionType;
(function (EHtmlSelectorActionType) {
    EHtmlSelectorActionType["value"] = "value";
    EHtmlSelectorActionType["getElement"] = "getElement";
    EHtmlSelectorActionType["insert"] = "insert";
    EHtmlSelectorActionType["click"] = "click";
    EHtmlSelectorActionType["fileDownload"] = "fileDownload";
})(EHtmlSelectorActionType = exports.EHtmlSelectorActionType || (exports.EHtmlSelectorActionType = {}));
var EHtmlSelectorType;
(function (EHtmlSelectorType) {
    EHtmlSelectorType["select"] = "select";
    EHtmlSelectorType["text"] = "text";
})(EHtmlSelectorType = exports.EHtmlSelectorType || (exports.EHtmlSelectorType = {}));
var EHtmlValueType;
(function (EHtmlValueType) {
    EHtmlValueType["many"] = "many";
    EHtmlValueType["one"] = "one";
})(EHtmlValueType = exports.EHtmlValueType || (exports.EHtmlValueType = {}));
var ELoopOptions;
(function (ELoopOptions) {
    ELoopOptions["all"] = "all";
})(ELoopOptions = exports.ELoopOptions || (exports.ELoopOptions = {}));
var EStoreType;
(function (EStoreType) {
    EStoreType["array"] = "ARRAY";
    EStoreType["map"] = "MAP";
    EStoreType["object"] = "OBJECT";
})(EStoreType = exports.EStoreType || (exports.EStoreType = {}));
var ECrawlerActions;
(function (ECrawlerActions) {
    ECrawlerActions["fetchMultipleFacilitiesData"] = "fetchMultipleFacilitiesData";
    ECrawlerActions["fetchFacilityResidents"] = "fetchFacilityResidents";
})(ECrawlerActions = exports.ECrawlerActions || (exports.ECrawlerActions = {}));
